import { axios, APIBASE_REVIVERUSERS } from "./ApiConfig";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { DeviationProduct } from "@/types";
import { DeviationProductFormInput } from "@/components/pages/Settings/validation/deviationProductValidationSchema";

const getDeviationProducts = async (companyId: number, includeDisabled: boolean) =>
  axios.get<DeviationProduct[]>(
    `${APIBASE_REVIVERUSERS}api/company/settings/deviationProducts?companyId=${companyId}&includeDisabled=${includeDisabled}`
  );

/** The company's deviation products, for its settings and its receiving inspections. */
export const useGetDeviationProducts = (
  companyId: number,
  includeDisabled: boolean,
  options?: Partial<UseQueryOptions<DeviationProduct[]>>
) =>
  useQuery<DeviationProduct[]>({
    queryKey: ["deviationProducts", companyId, includeDisabled],
    queryFn: async () => (await getDeviationProducts(companyId, includeDisabled)).data,
    refetchOnWindowFocus: false,
    ...options,
  });

// The description is optional, so a blank one is sent as null.
const toDeviationProductBody = ({ description, ...product }: DeviationProductFormInput) => ({
  ...product,
  description: description.trim() || null,
});

export const createDeviationProduct = async (product: DeviationProductFormInput) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/settings/deviationProducts`, toDeviationProductBody(product));

export const updateDeviationProduct = async (productId: number, product: DeviationProductFormInput) =>
  axios.put(
    `${APIBASE_REVIVERUSERS}api/company/settings/deviationProducts/${productId}`,
    toDeviationProductBody(product)
  );

export const deactivateDeviationProduct = async (productId: number) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/settings/deviationProducts/${productId}/disable`);

export const activateDeviationProduct = async (productId: number) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/settings/deviationProducts/${productId}/enable`);
